import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, of, tap } from 'rxjs';
import { AppInitializationStatus } from './initialization.types';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { ConsoleStatus } from 'src/app/shared/entities/console-status';

@Injectable({
  providedIn: 'root',
})
export class InitializationService {
  private apiService = inject(ApiService);
  private appInitializationStatusSubj = new BehaviorSubject(
    AppInitializationStatus.initializing,
  );
  appInitializationStatus: Observable<AppInitializationStatus> =
    this.appInitializationStatusSubj.asObservable();

  constructor() {
    this.updateConsoleStatus();
  }

  private updateConsoleStatus() {
    this.apiService
      .getConsoleStatus()
      .pipe(
        tap(status => {
          if (status === ConsoleStatus.UP) {
            this.appInitializationStatusSubj.next(
              AppInitializationStatus.consoleUp,
            );
          }
          if (status === ConsoleStatus.DOWN) {
            this.appInitializationStatusSubj.next(
              AppInitializationStatus.consoleDown,
            );
          }
        }),
        catchError(error => {
          console.error('Error getting console status', error);
          this.appInitializationStatusSubj.next(AppInitializationStatus.fail);
          return of();
        }),
      )
      .subscribe();
  }
}
